<template>
    <div class="app-input">
        <Field
            v-slot="{ field, errors, meta }"
            :name="fieldName"
            :rules="rules"
            :model-value="modelValue"
        >
        <div v-if="row" style="display: flex; align-items: flex-start">
            <div style="display: flex;  flex-direction: column;margin-right: 10px;min-width: 100px; max-width: 50%; padding-top: 10px">
                <div style="color: #757575;  ; ">{{label}}</div>
                <div v-if="errors && errors.length" class="error--text text-caption">{{errors[0]}}</div>
            </div>


            <slot :errors="errors" :valid="meta.valid" :field="field"></slot>
            <HelperMessage
                v-if="helperMessage"
                :message="helperMessage"
            />
        </div>
        <div v-else>

                <div style="display: flex">
                    <div style="color: #757575">{{label}}</div>
	                <HelperMessage
		                v-if="helperMessage"
		                :message="helperMessage"
	                />
	                <div v-if="errors && errors.length" class="error--text text-caption">{{errors[0]}}</div>
                </div>

                <slot :errors="errors" :valid="meta.valid" :field="field"></slot>


        </div>
        </Field>
    </div>
</template>

<script>
import { Field, defineRule, configure } from 'vee-validate'
import { digits, email, length, max, numeric, regex, required } from '@vee-validate/rules'
import HelperMessage from "@/components/HelperMessage"

// Configure interaction mode
configure({
  validateOnInput: true,
  validateOnBlur: true,
  validateOnChange: true,
  validateOnModelUpdate: true,
})

// Define rules
defineRule('digits', digits)
defineRule('required', required)
defineRule('max', max)
defineRule('numeric', numeric)
defineRule('regex', regex)
defineRule('email', email)
defineRule('length', length)

defineRule('positive', (value) => {
    if (value >= 0) return true
    return 'must be a positive number'
})

defineRule('inches', (value) => {
    if (value < 12 && value >= 0) return true
    return 'invalid'
})

defineRule('feet', (value) => {
    if (value < 11 && value >= 0) return true
    return 'invalid'
})

defineRule('centimeters', (value) => {
    if (value < 300) return true
    return 'must be less than 300'
})

defineRule('decimal', (value) => {
    if (isNaN(value) === false) return true
    return 'must be a number or decimal'
})

// mirrors ValidationManager.ValidatePersonName on the server (PT37546_3)
defineRule('personName', (value) => {
    if (!value || !value.trim()) return true
    const name = value.trim()
    if (!/^[\p{L}\p{M} '’\-.]+$/u.test(name) || !/\p{L}/u.test(name)) {
        return 'can only contain letters, spaces, apostrophes, hyphens and periods'
    }
    if (/\.[\p{L}\p{M}\p{N}]{2,}/u.test(name)) {
        return 'looks like a web address. Add a space after the period'
    }
    return true
})

defineRule('password', (value) => {
    if (value && value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]{6,}$/)) {
        return true
    }
    return 'must contain at least one uppercase letter, one lowercase letter, and one number'
})

export default {
    name: "AppInput",
    props: {
        errorLabel: {
            required: false
        },
        name: {
            required: true
        },
        rules: {

        },
        label: {

        },
        row: {
            type: Boolean,
            default: false
        },
        helperMessage: {
            required: false
        },
        modelValue: {
            required: false
        }
    },
    computed: {
        fieldName() {
            // Provide a fallback to prevent vee-validate from crashing when path is undefined
            return this.errorLabel || this.name || this.label || 'field'
        }
    },
    components: {
        HelperMessage,
        Field
    },
}
</script>

<style scoped>
.error--text {
    color: #ff5252;
}
</style>
